module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Flashlight-fd844d91d21a541af3ec0ad46e0d93d0.svg";